export { default as createSpanTagWrapper } from './create-span-tag-wrapper';
